import React from 'react';

import { Input } from 'components/WrappedComponents';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { CSSUtils } from 'utils/CSSUtils';
import { LABEL_ID_CORRELATION } from 'utils/global';

import { FilterDashboardFourriereProps } from '../../../types';

function InputIdCorrelation({
  values,
}: FilterDashboardFourriereProps): React.ReactElement {
  return (
    <Input
      wrapperProps={{
        values: values,
        fieldKey: 'idCorrelation',
        itemProps: {
          label: LABEL_ID_CORRELATION,
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
      }}
      inputProps={{ placeholder: FormPlaceholders.Input }}
    />
  );
}

export default InputIdCorrelation;
